import BackgroundAudioButton from '@/components/admin/SlideShow/Builder/BackgroundAudioButton/BackgroundAudioButton';

export default BackgroundAudioButton;
